import React, { useContext } from 'react'
import { bool, oneOf, object, func, string } from 'prop-types'

// components
import {
  ACCORDION_TITLES,
  DetailContentFactory,
} from 'containers/Detail/partials'
import { Accordion } from 'components/molecules'
import * as Styled from './DetailsMapper.styles'

// helpers
import { TextContext } from 'hocs'
import { BOOKABLE_TYPES } from 'settings/app/constants'
import { useSelector } from 'react-redux'

const DetailsMapper = (props) => {
  // handler
  const { backLink, setOpenAccordionKey } = props

  // props
  const { selectedType, result, isTreatmentReason, openAccordionKey } = props

  const { details } = result

  const state = useSelector((state) => state)
  const { compare: CompareState } = state
  const { detailsKeyArray } = CompareState.types[selectedType]

  const textContext = useContext(TextContext)
  const DISCLAIMER_ANCHOR_ID = 'maintainable-text-disclaimer'

  const getMaintainableDisclaimer = (id) => {
    const { maintainableTextDisclaimer } = result
    if (!maintainableTextDisclaimer) return null
    return maintainableTextDisclaimer.indexOf(id) > -1
      ? DISCLAIMER_ANCHOR_ID
      : null
  }

  return (
    <Styled.DetailsMapper>
      {detailsKeyArray.map((key, index) => {
        if (!details.hasOwnProperty(key)) return false

        const itemData = details[key]

        if (itemData === null) {
          return false
        }

        const label =
          (ACCORDION_TITLES[selectedType] &&
            ACCORDION_TITLES[selectedType].hasOwnProperty(key) &&
            textContext[`${ ACCORDION_TITLES[selectedType][key] }.title`]) ||
          textContext[`${ key }.title`] ||
          ''

        return (
          <Accordion
            key={ index }
            className={ `compare-accordion ${ key }` }
            label={ label }
            tooltip={
              itemData.hasOwnProperty('itemData') ? itemData.itemData : false
            }
            disclaimerAnchor={ getMaintainableDisclaimer(key) }
            open={ openAccordionKey === key }
            triggerStateChangeToParent={ () => setOpenAccordionKey(key) }>
            <DetailContentFactory
              detailsKey={ key }
              entryPoint={ selectedType }
              resultData={ result }
              itemData={ itemData }
              isTreatmentReason={ isTreatmentReason }
              backLink={ () => backLink() }
            />
          </Accordion>
        )
      })}
    </Styled.DetailsMapper>
  )
}

DetailsMapper.propTypes = {
  selectedType: oneOf(BOOKABLE_TYPES).isRequired,
  result: object.isRequired,
  isTreatmentReason: bool.isRequired,
  backLink: func.isRequired,
  openAccordionKey: string.isRequired,
  setOpenAccordionKey: func.isRequired,
}

export default DetailsMapper
